/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOneBaseMgmtManufacturerControllerManufacturerCompany } from '../fn/manufacturer/create-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { CreateOneBaseMgmtManufacturerControllerManufacturerCompany$Params } from '../fn/manufacturer/create-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { createOneBaseMgmtManufacturerTargetControllerManufacturerTarget } from '../fn/manufacturer/create-one-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { CreateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params } from '../fn/manufacturer/create-one-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { deleteOneBaseMgmtManufacturerControllerManufacturerCompany } from '../fn/manufacturer/delete-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { DeleteOneBaseMgmtManufacturerControllerManufacturerCompany$Params } from '../fn/manufacturer/delete-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget } from '../fn/manufacturer/delete-one-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { DeleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params } from '../fn/manufacturer/delete-one-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { getManyBaseMgmtManufacturerControllerManufacturerCompany } from '../fn/manufacturer/get-many-base-mgmt-manufacturer-controller-manufacturer-company';
import { GetManyBaseMgmtManufacturerControllerManufacturerCompany$Params } from '../fn/manufacturer/get-many-base-mgmt-manufacturer-controller-manufacturer-company';
import { getManyBaseMgmtManufacturerTargetControllerManufacturerTarget } from '../fn/manufacturer/get-many-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { GetManyBaseMgmtManufacturerTargetControllerManufacturerTarget$Params } from '../fn/manufacturer/get-many-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { GetManyManufacturerCompanyResponseDto } from '../models/get-many-manufacturer-company-response-dto';
import { GetManyManufacturerTargetResponseDto } from '../models/get-many-manufacturer-target-response-dto';
import { getOneBaseMgmtManufacturerControllerManufacturerCompany } from '../fn/manufacturer/get-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { GetOneBaseMgmtManufacturerControllerManufacturerCompany$Params } from '../fn/manufacturer/get-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { getOneBaseMgmtManufacturerTargetControllerManufacturerTarget } from '../fn/manufacturer/get-one-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { GetOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params } from '../fn/manufacturer/get-one-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { ManufacturerCompany } from '../models/manufacturer-company';
import { ManufacturerTarget } from '../models/manufacturer-target';
import { updateOneBaseMgmtManufacturerControllerManufacturerCompany } from '../fn/manufacturer/update-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { UpdateOneBaseMgmtManufacturerControllerManufacturerCompany$Params } from '../fn/manufacturer/update-one-base-mgmt-manufacturer-controller-manufacturer-company';
import { updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget } from '../fn/manufacturer/update-one-base-mgmt-manufacturer-target-controller-manufacturer-target';
import { UpdateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params } from '../fn/manufacturer/update-one-base-mgmt-manufacturer-target-controller-manufacturer-target';

@Injectable({ providedIn: 'root' })
export class ManufacturerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtManufacturerControllerManufacturerCompany()` */
  static readonly GetManyBaseMgmtManufacturerControllerManufacturerCompanyPath = '/api/mgmt/manufacturers';

  /**
   * Retrieve multiple ManufacturerCompanies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtManufacturerControllerManufacturerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtManufacturerControllerManufacturerCompany$Response(params?: GetManyBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyManufacturerCompanyResponseDto>> {
    const obs = getManyBaseMgmtManufacturerControllerManufacturerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ManufacturerCompanies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtManufacturerControllerManufacturerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtManufacturerControllerManufacturerCompany(params?: GetManyBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<GetManyManufacturerCompanyResponseDto> {
    const resp = this.getManyBaseMgmtManufacturerControllerManufacturerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyManufacturerCompanyResponseDto>): GetManyManufacturerCompanyResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtManufacturerControllerManufacturerCompany()` */
  static readonly CreateOneBaseMgmtManufacturerControllerManufacturerCompanyPath = '/api/mgmt/manufacturers';

  /**
   * Create a single ManufacturerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtManufacturerControllerManufacturerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params: CreateOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerCompany>> {
    const obs = createOneBaseMgmtManufacturerControllerManufacturerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single ManufacturerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtManufacturerControllerManufacturerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtManufacturerControllerManufacturerCompany(params: CreateOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<ManufacturerCompany> {
    const resp = this.createOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ManufacturerCompany>): ManufacturerCompany => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtManufacturerControllerManufacturerCompany()` */
  static readonly GetOneBaseMgmtManufacturerControllerManufacturerCompanyPath = '/api/mgmt/manufacturers/{id}';

  /**
   * Retrieve a single ManufacturerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtManufacturerControllerManufacturerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params: GetOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerCompany>> {
    const obs = getOneBaseMgmtManufacturerControllerManufacturerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ManufacturerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtManufacturerControllerManufacturerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtManufacturerControllerManufacturerCompany(params: GetOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<ManufacturerCompany> {
    const resp = this.getOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ManufacturerCompany>): ManufacturerCompany => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtManufacturerControllerManufacturerCompany()` */
  static readonly DeleteOneBaseMgmtManufacturerControllerManufacturerCompanyPath = '/api/mgmt/manufacturers/{id}';

  /**
   * Delete a single ManufacturerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtManufacturerControllerManufacturerCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params: DeleteOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtManufacturerControllerManufacturerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ManufacturerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtManufacturerControllerManufacturerCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtManufacturerControllerManufacturerCompany(params: DeleteOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtManufacturerControllerManufacturerCompany()` */
  static readonly UpdateOneBaseMgmtManufacturerControllerManufacturerCompanyPath = '/api/mgmt/manufacturers/{id}';

  /**
   * Update a single ManufacturerCompany.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtManufacturerControllerManufacturerCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params: UpdateOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerCompany>> {
    const obs = updateOneBaseMgmtManufacturerControllerManufacturerCompany(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single ManufacturerCompany.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtManufacturerControllerManufacturerCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtManufacturerControllerManufacturerCompany(params: UpdateOneBaseMgmtManufacturerControllerManufacturerCompany$Params, context?: HttpContext): Observable<ManufacturerCompany> {
    const resp = this.updateOneBaseMgmtManufacturerControllerManufacturerCompany$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ManufacturerCompany>): ManufacturerCompany => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtManufacturerTargetControllerManufacturerTarget()` */
  static readonly GetManyBaseMgmtManufacturerTargetControllerManufacturerTargetPath = '/api/mgmt/manufacturer/{manufacturerId}/targets';

  /**
   * Retrieve multiple ManufacturerTargets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtManufacturerTargetControllerManufacturerTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params: GetManyBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyManufacturerTargetResponseDto>> {
    const obs = getManyBaseMgmtManufacturerTargetControllerManufacturerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ManufacturerTargets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtManufacturerTargetControllerManufacturerTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtManufacturerTargetControllerManufacturerTarget(params: GetManyBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<GetManyManufacturerTargetResponseDto> {
    const resp = this.getManyBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyManufacturerTargetResponseDto>): GetManyManufacturerTargetResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` */
  static readonly CreateOneBaseMgmtManufacturerTargetControllerManufacturerTargetPath = '/api/mgmt/manufacturer/{manufacturerId}/targets';

  /**
   * Create a single ManufacturerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params: CreateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerTarget>> {
    const obs = createOneBaseMgmtManufacturerTargetControllerManufacturerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single ManufacturerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtManufacturerTargetControllerManufacturerTarget(params: CreateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<ManufacturerTarget> {
    const resp = this.createOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ManufacturerTarget>): ManufacturerTarget => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` */
  static readonly GetOneBaseMgmtManufacturerTargetControllerManufacturerTargetPath = '/api/mgmt/manufacturer/{manufacturerId}/targets/{id}';

  /**
   * Retrieve a single ManufacturerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params: GetOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerTarget>> {
    const obs = getOneBaseMgmtManufacturerTargetControllerManufacturerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ManufacturerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtManufacturerTargetControllerManufacturerTarget(params: GetOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<ManufacturerTarget> {
    const resp = this.getOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ManufacturerTarget>): ManufacturerTarget => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` */
  static readonly DeleteOneBaseMgmtManufacturerTargetControllerManufacturerTargetPath = '/api/mgmt/manufacturer/{manufacturerId}/targets/{id}';

  /**
   * Delete a single ManufacturerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params: DeleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ManufacturerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget(params: DeleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` */
  static readonly UpdateOneBaseMgmtManufacturerTargetControllerManufacturerTargetPath = '/api/mgmt/manufacturer/{manufacturerId}/targets/{id}';

  /**
   * Update a single ManufacturerTarget.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params: UpdateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerTarget>> {
    const obs = updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single ManufacturerTarget.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget(params: UpdateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<ManufacturerTarget> {
    const resp = this.updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ManufacturerTarget>): ManufacturerTarget => r.body)
    );
  }

}
